var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, state } from 'lit/decorators.js';
import { html, LitElement } from 'lit';
import { Modal } from 'flowbite';
import { bigGalleryIndexChange$, modal$ } from '../stores/store-main.js';
import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';
import { arrowSvg, crossSvg, image0 } from '../helpers/elements.js';
import { getBiggestImageUrl } from '../helpers/multiImage.js';
import { classMap } from 'lit/directives/class-map.js';
import { SubscriptionsController } from '../helpers/SubscriptionsController.js';
let ElementBigGallery = class ElementBigGallery extends LitElement {
    constructor() {
        super(...arguments);
        this.activeIndex = 0;
        this.loading = true;
        this.subscriptionController = new SubscriptionsController(this, () => [
            modal$.subscribe((options) => {
                if (options?.type === 'gallery') {
                    this.gallery = options.data.photos;
                    this.activeIndex = options.data.index;
                    if (this.modal)
                        this.showModal();
                }
                else if (this.gallery) {
                    this.modal._destroyBackdropEl = function () {
                        if (!this._isHidden) {
                            document.querySelector('.big-gallery-backdrop').remove();
                        }
                    };
                    this.modal.hide();
                    this.gallery = undefined;
                    this.activeIndex = 0;
                    this.swiper.destroy();
                    this.swiper = undefined;
                    this.loading = true;
                }
            }),
        ]);
    }
    hideOnOutsideClick() {
        const ignoreElements = [
            '.swiper-button-prev-unique',
            '.swiper-button-next-unique',
            '.swiper-slide-active img',
        ];
        const handler = (event) => {
            if (!modal$.getValue()) {
                this.querySelector('#element-big-gallery-modal').removeEventListener('click', handler);
                return;
            }
            const ignore = !!ignoreElements.filter((query) => {
                let equal = false;
                let contains = false;
                this.querySelectorAll(query).forEach((el) => {
                    if (!equal)
                        equal = el.isEqualNode(event.target);
                });
                if (!equal)
                    this.querySelectorAll(query).forEach((el) => {
                        if (!contains)
                            contains = el.contains(event.target);
                    });
                return equal || contains;
            }).length;
            if (ignore)
                return;
            this.querySelector('#element-big-gallery-modal').removeEventListener('click', handler);
            modal$.next(undefined);
        };
        this.querySelector('#element-big-gallery-modal').addEventListener('click', handler);
    }
    render() {
        return html ` <div
      id="element-big-gallery-modal"
      tabindex="-1"
      class="popup top-0 z-[70] hidden h-full w-full"
    >
      <div class="overflow-hidden">
        <div
          id="swiper-big-gallery"
          class="swiper flex items-center justify-center min-h-[24px]"
        >
          ${this.loading
            ? html `<div
                  class="bg-loader-animated h-[24px] w-[24px] bg-no-repeat absolute top-[calc(50%-12px)] left-[calc(50%-12px)] z-50"
                ></div>` : ''}
          <div class="swiper-wrapper items-center">
            ${this.gallery?.map((photo) => {
            return html ` <div
                class="swiper-slide flex h-full !w-full items-center justify-center py-[40px] sm:py-0"
              >
                <div class="sm:w-[40px]">
                  <div
                    class="big-gallery-prev-btn swiper-button-prev-unique hidden h-[40px] w-[40px] cursor-pointer items-center justify-center bg-page-main ${classMap({ 'sm:flex': !this.loading })}"
                  >
                    ${arrowSvg({
                classes: 'fill-chm-red -rotate-180 w-[24px] h-[24px]',
            })}
                  </div>
                </div>
                <div class="px-[20px]">
                  ${this.renderImage(photo)}
                  <div
                    data-cy="gallery-mob-footer"
                    class="h-[101px] flex-col bg-white sm:h-[64px] sm:flex-row sm:items-center mdxx:h-[88px] ${classMap({ flex: !this.loading, hidden: this.loading })}"
                  >
                    <div>
                      <div
                        .hidden="${!photo.caption}"
                        class="pl-[12px] sm:pl-[24px] sm:text-h4 mdxx:text-sm-h4"
                      >
                        ${photo.caption}
                      </div>
                      <div
                        .hidden="${!photo.copyright}"
                        class="pl-[12px] pt-[12px] sm:pl-[24px] sm:pt-0 sm:text-h4 mdxx:text-sm-h4 text-chm-gray"
                      >
                        \u00A9 ${photo.copyright}
                      </div>
                    </div>
                    <div
                      class="ml-auto flex gap-x-[20px] p-[14px] sm:hidden ${classMap({
                flex: !this.loading,
                hidden: this.loading,
            })}"
                    >
                      <div
                        class="big-gallery-prev-btn swiper-button-prev-unique z-20 flex h-[40px] w-[40px] cursor-pointer items-center justify-center bg-page-main"
                      >
                        ${arrowSvg({
                classes: 'fill-chm-red -rotate-180 w-[24px] h-[24px]',
            })}
                      </div>
                      <div
                        class="big-gallery-next-btn swiper-button-next-unique z-20 flex h-[40px] w-[40px] cursor-pointer items-center justify-center bg-page-main"
                      >
                        ${arrowSvg({
                classes: 'fill-chm-red w-[24px] h-[24px]',
            })}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="sm:w-[40px]">
                  <div
                    class="big-gallery-next-btn swiper-button-next-unique hidden h-[40px] w-[40px] cursor-pointer items-center justify-center bg-page-main ${classMap({
                'sm:flex': !this.loading,
            })}"
                  >
                    ${arrowSvg({ classes: 'fill-chm-red w-[24px] h-[24px]' })}
                  </div>
                  <div
                    class="close-gallery-btn absolute right-[20px] top-0 cursor-pointer sm:right-auto"
                    .hidden=${this.loading}
                    @click="${() => modal$.next(undefined)}"
                  >
                    ${crossSvg('h-[17px] w-[17px] fill-white')}
                  </div>
                </div>
              </div>`;
        })}
          </div>
        </div>
      </div>
    </div>`;
    }
    renderImage(photo) {
        if (photo.urls) {
            const defaultSrc = getBiggestImageUrl(photo.urls);
            return html `
        <img
          class="max-h-big-gallery !w-auto"
          src="${defaultSrc}"
          srcset="
            ${Object.entries(photo.urls)
                .map(([size, src]) => `${src} ${Number(size.split('X')[0])}w`)
                .join(', ')}
          "
          sizes="100vw"
          alt=""
          loading="lazy"
          @load=${() => {
                this.loading = false;
            }}
        />
      `;
        }
        else {
            return html `
        <img
          class="max-h-big-gallery !w-auto"
          src="${image0(photo.srcBig ||
                photo.src ||
                getBiggestImageUrl(photo.urls) ||
                photo.urlMaster)}"
          alt=${photo.abstract || ''}
          loading="lazy"
          @load=${() => {
                this.loading = false;
            }}
        />
      `;
        }
    }
    showModal() {
        this.modal.show();
        setTimeout(() => this.hideOnOutsideClick(), 500);
    }
    firstUpdated() {
        this.modal = new Modal(this.querySelector('#element-big-gallery-modal'), {
            placement: 'center',
            backdropClasses: 'big-gallery-backdrop modal-backdrop bg-black/75 fixed inset-0 z-[60]',
            closable: false,
        });
    }
    updated(changedProps) {
        if (changedProps.has('gallery') && this.gallery) {
            this.swiper = new Swiper('#swiper-big-gallery', {
                slidesPerView: 1,
                spaceBetween: 0,
                centeredSlides: true,
                navigation: {
                    nextEl: '.big-gallery-next-btn',
                    prevEl: '.big-gallery-prev-btn',
                },
                modules: [Navigation],
                on: {
                    activeIndexChange: (swiper) => {
                        bigGalleryIndexChange$.next(swiper.activeIndex);
                    },
                },
            });
            this.swiper.activeIndex = this.activeIndex;
            this.swiper.update();
        }
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    state()
], ElementBigGallery.prototype, "gallery", void 0);
__decorate([
    state()
], ElementBigGallery.prototype, "activeIndex", void 0);
__decorate([
    state()
], ElementBigGallery.prototype, "loading", void 0);
ElementBigGallery = __decorate([
    customElement('element-big-gallery')
], ElementBigGallery);
export default ElementBigGallery;
//# sourceMappingURL=element-big-gallery.js.map